<template>
  <div
    v-if="displayIndex"
    id="h4hHotelIndex"
    class="event"
  >
    <transition
      name="fade"
    >
      <div
        v-if="this.$store.state.hotel.loading"
        class="initial-hotels-load"
      />
    </transition>
    <div class="retail-hotel-filter-container mobile-filter">
      <HotelFilter />
    </div>
    <div
      v-if="this.$store.state.hotel.showMap && !this.$store.state.hotel.loading"
      class="map-view-container"
    >
      <HotelsMap />
    </div>
    <div
      v-else-if="!this.$store.state.hotel.showMap && !this.$store.state.hotel.loading"
      class="hotel-index-container"
    >
      <H4HBreadcrumbs />


      <div class="purchase-path-nav-parent">
        <div class="purchase-path-nav" />
        <a
          v-if="!hotelIsSelected"
          class="back-to-package"
          :href="packagePath"
        >{{ $t('h4h.back') }}</a>
        <a
          v-else
          class="back-to-package pointer"
          @click.prevent="deselectSpecifiedHotel"
        >
          {{ $t('h4h.seeAllProperties') }}
        </a>
        <a
          class="mobile-h4h-proceed-to-checkout proceed-to-checkout"
          href="/cart/checkout"
        >{{ $t('h4h.checkoutStep') }}</a>
        <a
          class="proceed-to-checkout"
          href="/cart/checkout"
        >{{ $t('h4h.noHotelProceed') }}</a>
      </div>
      <div v-if="!hotelIsSelected">
        <h3 class="hotel-index-header">
          {{ $t('h4h.chooseOptionalAccomodation') }}
        </h3>
        <p class="hotel-index-description">
          {{ $t('h4h.chooseAccomodationDescription', {
            brand_name: brandName
          }) }}
          <a href="/cart/checkout">{{ $t('h4h.clickHereToContinue') }}</a>
        </p>

        <ContractHotelIndex
          v-if="contractedAvailable"
        />
        <HotelOfferings
          v-if="contractedAvailable && retailHotelsAllowed"
        />
        <RetailHotelIndex
          v-if="this.$store.state.hotel.showRetailIndex || !contractedAvailable"
        />
      </div>
      <HotelOverview
        v-if="this.$store.state.hotel.hotel"
        :order="order"
      />
    </div>
  </div>
</template>

<script>
/* global locale */

import HotelFilter from './retail_hotel_filter'
import Api from '../../cart/cart_api'
import FetchCall from '../../local_fetch_call'
import Hotel from '../../../classes/hotel'
import H4HBreadcrumbs from './h4h_breadcrumb'
import HotelsMap from './hotels_map'
import ContractHotelIndex from './contract_hotel_index'
import HotelOfferings from './hotel_offerings'
import RetailHotelIndex from './retail_hotel_index'
import HotelOverview from '../h4h_rooms/hotel_overview'
import mixin from './hotel_availability'
import { mapMutations, mapGetters } from 'vuex'

export default {
  components: {
    HotelFilter,
    H4HBreadcrumbs,
    HotelsMap,
    RetailHotelIndex,
    ContractHotelIndex,
    HotelOfferings,
    HotelOverview
  },

  mixins: [mixin],

  data() {
    return {
      brandName: window.brand_name,
      loading: false,
      displayIndex: false,
      hotels: [],
      order: {},
      orderItem: {},
      package: {},
      orderHotelId: {
        default: null,
        required: false
      },
      selectedStay: {
        default: null,
        requried: false
      },
      roomQty: Number
    }
  },

  computed: {
    ...mapGetters('hotel', ['getContractedHotels']),
    contractedAvailable() {
      return this.getContractedHotels.length > 0 ? true : false
    },
    tempPackage() {
      let pack = this.package
      pack.purchasable_hotels = this.hotels
      return pack
    },
    retailHotelsAllowed() {
      return this.order.event_hotel_behavior !='contracted_only' ? true : false
    },

    packagePath() {
      const packageId = this.$store.state.packages.packageId
      return `/${locale}/packages/${packageId}/path`
    },

    hotelIsSelected() {
      return this.$store.state.hotel.hotel ? true : false
    }
  },

  created() {
    this.setLoading(true)
    window.history.replaceState(null, null, 'hotels')

    if(window.location.pathname.charAt(window.location.pathname.length -1) === '/'){
      window.history.replaceState(null, null, '../hotels')
    }
    else{
      window.history.replaceState(null, null, './hotels')
    }
    this.getOrder()
  },

  updated(){
    this.redirectIfNoPkg()
  },

  methods: {
    ...mapMutations('hotel', [
      'setLoading',
      'updateDestination',
      'updateVenue',
      'updateLatitude',
      'updateLongitude',
      'updateCheckInDate',
      'updateCheckOutDate',
      'updateContractedCheckInDate',
      'updateContractedCheckOutDate',
      'deselectHotel',
      'showRetailIndex',
      'addHotelToArray',
      'selectHotel'
    ]),

    ...mapMutations('orderItem', [
      'updateOrderItemId',
    ]),

    ...mapMutations('event', [
      'updateEventLocation',
    ]),

    ...mapMutations('packages', [
      'setPackageId',
      'updatePackageQty',
    ]),

    deselectSpecifiedHotel(){
      window.history.pushState(null, null, './hotels')
      this.deselectHotel()
    },
    async getHotels() {
      let res = await FetchCall.fetchWithoutLocale(
        `/api/packages/${this.$store.state.packages.packageId}/hotels`,
        'GET',
        null
      )

      this.hotels = res.hotels
      await this.createHotelObject(true)
    },

    getOrder() {
      return Api.getOrder().then(order => {
        if (order.cart_version == 'h4h') {
          let startDate = new Date(order.event_start_date)
          let endDate = new Date(order.event_end_date)
          startDate = startDate.setDate(startDate.getDate() + 1)
          endDate = endDate.setDate(endDate.getDate() + 1)
          this.displayIndex = true
          this.order = order
          this.updateVenue(order.event_venue)
          this.updateDestination(order.event_address)
          this.updateLatitude(order.event_latitude)
          this.updateLongitude(order.event_longitude)
          this.updateCheckInDate(new Date(startDate))
          this.updateCheckOutDate(new Date(endDate))
          this.updateContractedCheckInDate(new Date(startDate))
          this.updateContractedCheckOutDate(new Date(endDate))
          this.updateOrderItemId(this.orderItem.id)
          this.setItemAndHotels()
          this.updateEventLocation(order.event_location)
        }
      })
    },

    getItemNumber() {
      let pathArray = window.location.href.split('/')
      let pathItemId = pathArray.reverse()[1]
      let itemId = Number(pathItemId)
      return itemId
    },
    redirectIfNoPkg(){
      if(this.order.items.length===0){
        window.location.replace('/calendar-of-events')
      }
    },

    async setItemAndHotels() {
      let item = this.order.items.find(item => { return item.id == this.getItemNumber() })

      if (item) {
        this.orderItem = item
        this.setPackageId(item.package_id)
        this.updatePackageQty(item.quantity)
        await this.getHotels()
        if (item.hotel_id) {
          this.checkHotelInCart(item)
        }
      }
    },

    checkHotelInCart(item) {
      let hotels = this.getContractedHotels
      let hotel = hotels.find(hotel => { return hotel.qng_id == item.hotel_id })
      if (hotel) {
        this.selectHotel(hotel)
        window.history.pushState(hotel.id, null, `hotels#${hotel.id}`)
        window.addEventListener('popstate', e => {
          e.state !== null ? this.selectHotel(hotel) : this.selectHotel(null)
        })
      }
      else if (item.h4h_hotel_attributes.hotel_id) {
        this.fetchH4HHotelInfo(item.h4h_hotel_attributes)
      }
    },

    async fetchH4HHotelInfo(hotelAttributes) {
      let checkIn = this.getH4hDateFromAttributeString(hotelAttributes.hotel_check_in_date)
      let checkOut = this.getH4hDateFromAttributeString(hotelAttributes.hotel_check_out_date)

      let res = await FetchCall.fetchWithoutLocale(
        '/api/h4h_hotels' +
        `?latitude=${hotelAttributes.hotel_latitude}` +
        `&longitude=${hotelAttributes.hotel_longitude}` +
        `&inDate=${checkIn}` +
        `&outDate=${checkOut}` +
        `&rooms=${hotelAttributes.room_quantity}`,
        'GET',
        null
      )

      let hotels = res.ArnResponse.Availability.HotelAvailability.Hotel

      let index = hotels.map(x => {return x['@HotelID']}).indexOf(hotelAttributes.hotel_id)
      let hotel = new Hotel(hotels[index])
      await hotel.updateHotelInfo(this.order.event_latitude, this.order.event_longitude)

      checkIn = new Date(checkIn)
      checkOut = new Date(checkOut)
      const stayDuration =
        (checkOut - checkIn) / (1000*3600*24)
      // eslint-disable-next-line require-atomic-updates
      hotel.checkIn = new Date(checkIn).toLocaleDateString(locale,
        {month: 'numeric', day: 'numeric', year: 'numeric'})
      // eslint-disable-next-line require-atomic-updates
      hotel.checkOut = new Date(checkOut).toLocaleDateString(locale,
        {month: 'numeric', day: 'numeric', year: 'numeric'})
      // eslint-disable-next-line require-atomic-updates
      hotel.stayDuration = Math.ceil(stayDuration)

      this.addHotelToArray(hotel)
      this.selectHotel(hotel)
      window.history.pushState(hotel.id, null, `hotels#${hotel.id}`)
      window.addEventListener('popstate', e => {
        e.state !== null ? this.selectHotel(hotel) : this.selectHotel(null)
      })
      this.setLoading(false)
    },

    getH4hDateFromAttributeString(date) {
      let dateDay = date.substring(0, 2)
      let dateMonth = date.substring(3, 5)
      let dateYear = date.substring(6)
      return `${dateYear}-${dateMonth}-${dateDay}`
    },

    updateRoomQty(qty) {
      qty ? this.roomQty = qty : null
    }
  }
}
</script>
